import { useAccessControl, useCurrentUser } from '@billx/api';
import { WEB_DASHBOARD_NAV_TREE } from '@billx/utils';
import {
  BoltIcon,
  BookUserIcon,
  HomeIcon,
  LibraryBigIcon,
  PackageIcon,
  UsersRoundIcon,
} from 'lucide-react';
import type { ReactNode } from 'react';

import type { NavItem } from '@/components/common';

const TOP_ICONS: Record<string, ReactNode> = {
  home: <HomeIcon size={18} />,
  outlet: <LibraryBigIcon size={18} />,
  orders: <PackageIcon size={18} />,
  users: <UsersRoundIcon size={18} />,
  customers: <BookUserIcon size={18} />,
  settings: <BoltIcon size={18} />,
};

export const useDashboardNavItems = (): NavItem[] => {
  const { canAccessPage } = useAccessControl();
  const { currentUser } = useCurrentUser();

  if (!currentUser) {
    return [];
  }

  const allItems: NavItem[] = WEB_DASHBOARD_NAV_TREE.map((node) => {
    if (node.kind === 'item') {
      return {
        id: node.id,
        label: node.label,
        icon: TOP_ICONS[node.id],
        path: node.webPath,
        pageKey: node.pageKey,
      };
    }
    return {
      id: node.id,
      label: node.label,
      icon: TOP_ICONS[node.id],
      pageKey: node.pageKey,
      children: node.children.map((c) => ({
        id: c.id,
        label: c.label,
        path: c.webPath,
        pageKey: c.pageKey,
      })),
    };
  });

  return allItems
    .filter((item) => canAccessPage(item.pageKey))
    .map((item) => {
      return {
        ...item,
        children: item.children?.filter((child) =>
          canAccessPage(child.pageKey)
        ),
      };
    });
};
